/**
 * Shared React Context instance and types for tenant state.
 */

import { createContext } from 'react';

export interface Tenant {
  id: string;
  name: string;
  slug: string;
  role: 'owner' | 'admin' | 'member';
  createdAt: string;
}

export interface CreateTenantParams {
  name: string;
  slug?: string;
}

export interface TenantContextType {
  // Core state
  currentTenant: Tenant | null;
  tenants: Tenant[];
  isLoading: boolean;
  error: string | null;

  // Actions
  switchTenant: (tenantId: string) => Promise<void>;
  createTenant: (params: CreateTenantParams) => Promise<Tenant>;
  refreshTenants: () => Promise<void>;
  clearError: () => void;

  // Computed
  hasMultipleTenants: boolean;
  isMultitenancyEnabled: boolean;
}

export const TenantContext = createContext<TenantContextType | undefined>(undefined);
